/**
 * 台灣業務日（前端版，對應 server/utils/taiwanDate.ts）
 *
 * 系統的「今天」以台灣時區（Asia/Taipei, UTC+8）為準。
 * 不可用 `new Date().toISOString()` 截字串（UTC）——
 * 台灣 00:00–08:00 之間會落在 UTC 前一天，預設日期會變成昨天。
 */

const taiwanDateFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Taipei",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/** 回傳台灣時區的業務日字串（YYYY-MM-DD），可直接當 <input type="date"> 的值。 */
export function getTaiwanBusinessDateString(now: Date = new Date()): string {
  return taiwanDateFormatter.format(now);
}
